import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Badge.module.css.js';

const Badge = ({ children, variant = "primary", radius = "large", className, ...args }) => {
    return (jsx("div", { className: classNames(style.badge, style[variant], style[radius], className), ...args, children: children }));
};

export { Badge };
//# sourceMappingURL=Badge.js.map
